import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-blue-100 border-blue-400 text-blue-700 border px-4 py-3 rounded"
}
const _hoisted_2 = { class: "text-3xl font-medium" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.seminarDetails)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.seminarDetails.seminar_category_id === 1)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_ctx.categoryName) + "の参加登録を、 ", 1),
              _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
              _createTextVNode("「" + _toDisplayString(_ctx.seminarDetails.seminar_user.seminar_status.name) + "」で受付いたしました。 ", 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_ctx.categoryName) + "の参加登録を受付いたしました。 ", 1)
            ], 64)),
        _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
        _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
        _cache[3] || (_cache[3] = _createTextVNode("受付番号は ", -1)),
        _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
        _createElementVNode("span", _hoisted_2, "[" + _toDisplayString(_ctx.seminarDetails.seminar_user.order_key) + "]", 1),
        _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
        _cache[6] || (_cache[6] = _createTextVNode("になります。 ", -1))
      ]))
    : _createCommentVNode("", true)
}